import { useEffect } from 'react';

const SEO_DATA = {
  '/': {
    title: 'Qualiance International Limited | Technical Garment Manufacturer',
    description: 'Apparel Engineering at its Peak. Founded in 1994, Qualiance International Limited is a technical garment manufacturer specializing in Swiss military-spec outerwear, cold weather clothing (-30\u00b0C to -40\u00b0C), activewear, sustainable childrenswear, and high fashion. 45,000 sq. ft. facility in Tiruppur, India.',
    keywords: 'Qualiance International Limited, technical garment manufacturer, Swiss military clothing, cold weather garments, outerwear manufacturer India, Tiruppur garment factory, seam sealing, down filling, quilting, bonded assembly, ISO 9001, GOTS certified',
    canonical: 'https://qualiance.com/',
  },
  '/materials': {
    title: 'Fabric Complexity Scale | Materials Mastery | Qualiance International',
    description: 'From cotton jerseys to PTFE membrane composites \u2014 7 levels of manufacturing complexity under one roof. Qualiance handles knit and woven fabrics across 14 categories including Gore-Tex, aramid, softshell, and spacer mesh.',
    keywords: 'fabric complexity, technical textiles, Gore-Tex manufacturing, PTFE membrane, aramid kevlar, softshell bonded, ripstop nylon, woven fabrics, knit fabrics, GSM range',
    canonical: 'https://qualiance.com/materials',
  },
  '/sustainability': {
    title: 'Green Manufacturing | Sustainability | Qualiance International',
    description: 'Sustainability built into the factory from the ground up. 72kW rooftop solar installation, rainwater harvesting, multi-stage water treatment, zero-landfill waste segregation, and 40% carbon footprint reduction at Qualiance International.',
    keywords: 'sustainable garment manufacturing, solar powered factory, rainwater harvesting, water treatment plant, green manufacturing India, carbon reduction, fabric recycling, GOTS certified, GRS certified',
    canonical: 'https://qualiance.com/sustainability',
  },
  '/people': {
    title: 'Our People | Culture & Workforce | Qualiance International',
    description: 'Behind every stitch, a person. Qualiance invests in on-site healthcare, festival celebrations, creche facilities, rooftop dining, and next-generation training. 400+ skilled workforce in Tiruppur, Tamil Nadu.',
    keywords: 'Qualiance people, garment factory workers, Tiruppur workforce, factory healthcare, employee welfare, on-site creche, worker celebrations, NIFT-TEA cricket',
    canonical: 'https://qualiance.com/people',
  },
  '/investor-relations': {
    title: 'Investor Relations | Qualiance International Limited',
    description: 'Corporate governance, financial disclosures, and regulatory filings for Qualiance International Limited. Access annual reports, annual returns, DRHP, abridged prospectus, 15 governance policies, and investor grievance redressal.',
    keywords: 'Qualiance investor relations, annual report, annual return, DRHP, draft prospectus, abridged prospectus, SEBI LODR, corporate governance, board of directors, investor grievance',
    canonical: 'https://qualiance.com/investor-relations',
  },
};

function setMetaTag(name, content, attr = 'name') {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

const PageSEO = ({ path }) => {
  const data = SEO_DATA[path] || SEO_DATA['/'];

  useEffect(() => {
    document.title = data.title;
    setMetaTag('description', data.description);
    setMetaTag('keywords', data.keywords);
    setCanonical(data.canonical);

    // Open Graph
    setMetaTag('og:title', data.title, 'property');
    setMetaTag('og:description', data.description, 'property');
    setMetaTag('og:url', data.canonical, 'property');
    setMetaTag('og:type', 'website', 'property');
    setMetaTag('og:site_name', 'Qualiance International Limited', 'property');

    // Twitter Card
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', data.title);
    setMetaTag('twitter:description', data.description);
  }, [data]);

  return null;
};

export default PageSEO;
